<template>
  <div class="LegalDocuments">
    <HomerIntro />
    <HomeDesc />
  </div>
</template>

<script>
import HomerIntro from '@/components/legalDocuments/intro';
import HomeDesc from '@/components/legalDocuments/desc';
export default {
  name: 'LegalDocuments',
  components: {
    HomerIntro,
    HomeDesc
  }
}
</script>
